import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import AOS from 'aos';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import TablePaginated from '@app/components/table-paginated/TablePaginated';
import {Dropdown} from 'react-bootstrap';
import {showModal} from 'react-redux-modal-provider';
import {Button} from '@app/components/index';
import FechaFunction from '@app/functions/FechaFunction';
import ContactosAction from '@app/store/actions/contactos';
import ContactosService from '@app/services/contactos.service';
import ModalCVVEditar from '@app/modals/contacto/ModalCVVEditar';
import usePermisos from '@app/hooks/usePermisos';


const CvvCamarasPage = ({
    iniciarContacto,
    iniciarContrato
}) => {
    AOS.init();
    const [t] = useTranslation();
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [tipoSistema, setTipoSistema] = useState('TODOS');
    const permisos = usePermisos();

    const actualizar = async () => {
        ContactosService.getAll({
            type: 'cvv',
            tipoSistema: tipoSistema
        }).then((r)=>{
            setItems(r)
        })
    };

    const onGuardar = () => {
        actualizar();
    };

    const handleTipoSistemaChange = (e) => {
        setTipoSistema(e.target.value);
    };

    const onClickNuevo = () => {
        showModal(ModalCVVEditar, {onGuardar: onGuardar});
    };

    const onOpenVer = (item) => {
        navigate(`/segmentos/${item.id_c}/ver`);
    }

    const onOpenEditar = (item) => {
        showModal(ModalCVVEditar, {item: item, onGuardar: onGuardar});
    };

    const columns = React.useMemo(
        () => [
            {
                Header: 'Registrado',
                Filter: false,
                accessor: 'createdAt',
                disableGlobalFilter: true,
                Width: 90,
                Cell: ({row}) => {
                    if(row.original?.createdAt){
                        return FechaFunction.format(row.original?.createdAt,'dd/MM/yyyy');
                    }
                    return '';
                },
            },{
                Header: 'Nombre',
                accessor: 'nombre_c',
            },{
                Header: 'Direccion',
                accessor: 'direccion_c',
            },
            {
                Width: 170,
                Header: '',
                accessor: 'id',
                disableSortBy: false,
                Filter: false,
                Cell: ({row}) => (
                    (permisos && permisos['contacto.abm911']) ? (
                        <div className="d-flex justify-content-center">
                            <button
                                type="button"
                                className="btn btn-outline-primary btn-sm rounded-circle shadow-sm ml-2"
                                style={{
                                    width: '35px',
                                    height: '35px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: '2px solid #007bff',
                                    transition: 'all 0.3s ease'
                                }}
                                onClick={()=>onOpenVer(row.original)}
                                title="Ver detalles"
                            >
                                <i className="fas fa-eye" style={{fontSize: '14px'}} />
                            </button>
                            <button
                                type="button"
                                className="btn btn-outline-primary btn-sm rounded-circle shadow-sm ml-2"
                                style={{
                                    width: '35px',
                                    height: '35px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: '2px solid #007bff',
                                    transition: 'all 0.3s ease'
                                }}
                                onClick={()=>onOpenEditar(row.original)}
                                title="Editar"
                            >
                                <i className="fas fa-edit" style={{fontSize: '14px'}} />
                            </button>
                        </div>
                    ):(
                        <button 
                            type="button"
                            className="btn btn-outline-info btn-sm rounded-circle shadow-sm"
                            style={{
                                width: '35px',
                                height: '35px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: '1px solid #007bff',
                                transition: 'all 0.3s ease'
                            }}
                            onClick={()=>onOpenVer(row.original)}
                            title="Ver detalles"
                        >
                            <i className="fas fa-eye" style={{fontSize: '14px'}} />
                        </button>
                    )
                )
            }
        ],
        [permisos]
    );

    useEffect(()=>{
        actualizar();
    },[])

    useEffect(()=>{
        actualizar();
    },[tipoSistema])

    useEffect(() =>{ 
        iniciarContacto(null);
        iniciarContrato(null);
    },[])
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-6 my-1 col-md-6 col-lg-8 mt-lg-3" data-aos="fade-right">
                        <h2 className='user-select-none'>Segmentos</h2>
                    </div>
                    <div className="col-lg-3 col-md-6 mt-lg-3 my-1" data-aos="fade-down">
                        {permisos && permisos['contacto.abm911'] &&(
                            <Button color="primary" className="btn-block w-75 float-right" onClick={()=>onClickNuevo()}>
                                NUEVO
                            </Button>
                        )}
                    </div>
                    <div className="col-lg-4 col-md-6 mt-lg-1 my-1" data-aos="fade-down">
                        <div style={{fontWeight: 'bold'}}>Filtros:</div>
                        <div className="form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="tipoSistema"
                                id="todos"
                                value="TODOS"
                                checked={tipoSistema === 'TODOS'}
                                onChange={handleTipoSistemaChange}
                            />
                            <label className="form-check-label mr-3" htmlFor="todos">
                                TODOS
                            </label>
                            <input
                                className="form-check-input"
                                type="radio"
                                name="tipoSistema"
                                id="svv"
                                value="SVV"
                                checked={tipoSistema === 'SVV'}
                                onChange={handleTipoSistemaChange}
                            />
                            <label className="form-check-label mr-3" htmlFor="svv">
                                SVV
                            </label>
                            <input
                                className="form-check-input"
                                type="radio"
                                name="tipoSistema"
                                id="sge"
                                value="SGE"
                                checked={tipoSistema === 'SGE'}
                                onChange={handleTipoSistemaChange}
                            />
                            <label className="form-check-label mr-3" htmlFor="sge">
                                SGE
                            </label>
                            <input
                                className="form-check-input"
                                type="radio"
                                name="tipoSistema"
                                id="tetra"
                                value="TETRA"
                                checked={tipoSistema === 'TETRA'}
                                onChange={handleTipoSistemaChange}
                            />
                            <label className="form-check-label" htmlFor="tetra">
                                TETRA
                            </label>
                        </div>
                    </div>
                    <div className="col-12" data-aos="fade-right">
                        <TablePaginated columns={columns} data={items} />
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    contacto: state.contactos.current,
});

const mapDispatchToProps = (dispatch) => ({
    iniciarContacto: (data) => dispatch(ContactosAction.iniciarContacto(data)),
    iniciarContrato: (data) => dispatch(ContactosAction.iniciarContrato(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CvvCamarasPage);
